import Link from "next/link";
import { useRouter } from "next/router";
import {LucideLinkedin } from "lucide-react";
import { cn } from "@/lib/utils";

export default function Footer() {
  const router = useRouter();

  const routes = [
    {
      label: "Home",
      href: "/",
    },
    {
      label: "Blog",
      href: "/blog",
    },
  ];

  return (
    <footer className="mt-auto border-t border-zinc-200/50 dark:border-zinc-700/50">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-6">
        <div className="flex flex-col sm:flex-row justify-between gap-4">
          <div className="text-sm text-zinc-500 dark:text-zinc-400 italic">
            Web Performance & Engineering
          </div>
          
          <nav className="flex items-center gap-6">
            {routes.map((route) => {
              const isActive =
                router.pathname === route.href ||
                (route.href !== "/" && router.pathname.startsWith(route.href));

              return (
                <Link
                  key={route.href}
                  href={route.href}
                  className={cn(
                    "text-sm transition-colors",
                    isActive
                      ? "text-zinc-900 dark:text-zinc-100 font-medium"
                      : "text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100"
                  )}
                >
                  {route.label}
                </Link>
              );
            })}
            <Link
              href="https://www.linkedin.com/in/amrikmalhans/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100 transition-colors"
            >
              <LucideLinkedin className="w-4 h-4" />
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}

